import React, { CSSProperties, ReactNode } from 'react'
import { SemanticCOLORS, SemanticSIZES } from 'semantic-ui-react/dist/commonjs/generic'

interface Props {
  content: ReactNode;
  color: SemanticCOLORS | string;
  size?: SemanticSIZES;
  border?: string;
  height?: string;
  width?: string;
  textColor?: SemanticCOLORS | string;
  style?: CSSProperties;
}

const CircularLabel = (props: Props): JSX.Element  => {
  const { color, content, border, height, width, textColor, style } = props
  return (
    <div
      style={{
        ...style,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        border: border ? border : '',
        borderRadius: '50%',
        height: height ? height : '2.5rem',
        width: width ? width : '2.5rem',
        minHeight: height ? height : '2.5rem',
        minWidth: width ? width : '2.5rem',
        background: color,
        color: textColor ? textColor : 'white'
      }}>
      {content}
    </div>
  )
}

export default CircularLabel
